// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-22T09:54:31Z                      #

// ##############################################################

// @ts-ignore - not used import
import {AxiosInstance, AxiosResponse, AxiosRequestConfig, CancelToken} from 'axios';
// @ts-ignore - not used import
import {unwrapResponse, generateUrl, baseAxios} from '@mc/axios-api';
// @ts-ignore - not used import
import * as importUrl from 'url';
// @ts-ignore - not used import
import ApprovalTextVO from "./types/ApprovalTextVO";

// @ts-ignore - not used import
import * as UpdateMethods from "./UpdateMethods";


// @ts-ignore - not used import
type SimpleHeaders = {[key: string]: string};

/**
 *  Generated from cz.marbes.qsign.controller.QSignDocumentApproveController.
 */
export default class QSignDocumentApproveApi {
    /**
     * 
     *
     * @param pdfView 
     * @param documentView 
     * @param approvalText 
     */
    static rejectDocument(pdfView : string, documentView : string, approvalText : ApprovalTextVO, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(QSignDocumentApproveApi.raw.rejectDocument(pdfView, documentView, approvalText, config));
    }
    /**
     * 
     *
     * @param pdfView 
     * @param documentView 
     * @param approvalText 
     */
    static rejectAllDocuments(pdfView : string, documentView : string, approvalText : ApprovalTextVO, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(QSignDocumentApproveApi.raw.rejectAllDocuments(pdfView, documentView, approvalText, config));
    }
    /**
     * 
     *
     * @param pdfView 
     * @param documentView 
     */
    static prevezmi(pdfView : string, documentView : string, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(QSignDocumentApproveApi.raw.prevezmi(pdfView, documentView, config));
    }
    /**
     * 
     *
     * @param pdfView 
     * @param documentView 
     * @param approvalText 
     */
    static acceptAllDocuments(pdfView : string, documentView : string, approvalText : ApprovalTextVO, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(QSignDocumentApproveApi.raw.acceptAllDocuments(pdfView, documentView, approvalText, config));
    }
    /**
     * 
     *
     * @param pdfView 
     * @param documentView 
     * @param approvalText 
     */
    static acceptDocument(pdfView : string, documentView : string, approvalText : ApprovalTextVO, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(QSignDocumentApproveApi.raw.acceptDocument(pdfView, documentView, approvalText, config));
    }

    static raw = {
            rejectDocument: function(pdfView : string, documentView : string, approvalText : ApprovalTextVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/signRequest/${pdfView}/${documentView}/reject`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, approvalText, finalConfig);
            },
            rejectAllDocuments: function(pdfView : string, documentView : string, approvalText : ApprovalTextVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/signRequest/${pdfView}/${documentView}/rejectAll`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, approvalText, finalConfig);
            },
            prevezmi: function(pdfView : string, documentView : string, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/signRequest/${pdfView}/${documentView}/prevezmi`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, 0, finalConfig);
            },
            acceptAllDocuments: function(pdfView : string, documentView : string, approvalText : ApprovalTextVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/signRequest/${pdfView}/${documentView}/acceptAll`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, approvalText, finalConfig);
            },
            acceptDocument: function(pdfView : string, documentView : string, approvalText : ApprovalTextVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/signRequest/${pdfView}/${documentView}/accept`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, approvalText, finalConfig);
            },
    }
}
